import { throttle } from 'throttle-debounce'
import { PARAM_SEND_MS } from '~/lib/constants'
import socket from '~/lib/socket'

const _flush = updates => {
	if (socket.dc?.readyState !== 'open') return
	const objects = {}
	for (const upd of updates) objects[upd.id] = upd
	socket.sendDC('parameters', { objects })
}

export const sendInpaintMaskUpdates = throttle(PARAM_SEND_MS, _flush)
